import { createContext } from 'react';

export interface AIProvider {
  id: string;
  baseURL: string;
  apiKey?: string;
  nostr?: boolean;
  proxy?: boolean;
}

export interface ProjectTemplate {
  id: string;
  name: string;
  description: string;
  url: string;
}

export interface AISettings {
  providers: AIProvider[];
  recentlyUsedModels: string[];
  projectTemplates: ProjectTemplate[];
}

export interface AISettingsContextType {
  settings: AISettings;
  updateSettings: (settings: Partial<AISettings>) => void;
  setProvider: (provider: AIProvider) => void;
  removeProvider: (id: string) => void;
  setProviders: (providers: AIProvider[]) => void;
  addRecentlyUsedModel: (modelId: string) => void;
  addProjectTemplate: (template: ProjectTemplate) => void;
  updateProjectTemplate: (template: ProjectTemplate) => void;
  removeProjectTemplate: (id: string) => void;
  setProjectTemplates: (templates: ProjectTemplate[]) => void;
  isConfigured: boolean;
  /** Whether settings are still being loaded from storage */
  isLoading: boolean;
}

export const AISettingsContext = createContext<AISettingsContextType | undefined>(undefined);